import React, { Component, ComponentClass, ComponentType } from 'react'
import { createStyles, WithStyles, withStyles, Theme, Typography } from '@material-ui/core'
import { TEditSection, CONTENT_TYPE, SOURCE_TYPE, LANGUAGES } from '../../Features/AddNewLTDDocument/@types'
import { fade } from '@material-ui/core/styles/colorManipulator'
import THEME from '../../Resources/Theme';
import FormGroup, { IFormConfig } from '../FormGroup';
import BasicInformation from './BasicInformation';
import Relations from './Relations';
import JudicialDocuments from './JudicialDocuments';
import ICCDocuments from './ICCDocuments';
import Bibliography from './Bibliography';
import QualityControl from './QualityControl';


interface IProps extends WithStyles<typeof STYLES> {
    sectionId: TEditSection
    sectionTitle: string
}




class FormSection extends Component<IProps> {


    render() {
        const { classes, sectionId, sectionTitle } = this.props;

        const CONFIG: Record<TEditSection, JSX.Element> = {
            'basic-information': <BasicInformation />,
            'relations': <Relations />,
            'judicial-documents': <JudicialDocuments />,
            'icc-documents': <ICCDocuments />,
            'biblography': <Bibliography />,
            'quality-control': <QualityControl />
        }

        if (!CONFIG[sectionId]) return null;

        return (
            <div className={classes.root} id={sectionId}>
                <div className={classes.container}>
                    <div className={classes.title}>
                        <SectionLabel title={sectionTitle} />
                    </div>
                    <div className={classes.content}>
                        {CONFIG[sectionId]}
                    </div>
                </div>
            </div>
        )
    }
}


export const SectionLabel: React.FC<{ title: string }> = (props) => {
    return (
        <Typography style={{ background: THEME.Colors.Fourth, fontWeight: 500, color: 'white', padding: '0px 2px' }}>
            {props.title}
        </Typography>
    )
}

const STYLES = (theme: Theme) => createStyles({
    root: {
        // padding: '40px 0px 60px 0px',
        borderBottom: `1px dashed ${fade('#000', 0.2)}`
    },
    title: {
        marginBottom: 16,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    content: {
        background: 'white',
        padding: '20px 10px',
        maxWidth: 680,
        borderRadius: 4,
        margin: '0 auto',
        width: '100%',
    },
    container: {
        padding: '60px 0px 160px 0px',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        width: 680,
        margin: '0 auto',
    },
    formContainer: {

    }
})

export default withStyles(STYLES)(FormSection)